import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => (
  <img src={`/img/svg/${src}`} alt={src} width={width} height={height} />
);
export const SvgIcon2 = ({ src, style, ...rest }: { src: string; style?: React.CSSProperties }) => {
  return <img src={`/img/svg/${src}`} alt={src} style={{ ...style }} {...rest} />;
};